// extracted by mini-css-extract-plugin
export var arrow = "_l9-1";
export var content = "_l9-0";
export var highlighted = "_l9-2";